import {useState} from "react";
import TableList from "../../../component/TableList/TableList";
import {normalizeTimestemp} from "../../../utils/normalizeTimestemp";
import FilterDueDateChanges from "./FilterDueDateChanges";
import DueDateChangesActions from "./DueDateChangesActions";
import {numberWithPoints} from "../../../utils/numberWithPoints";


export default function DueDateChangesList({
                                               baseUrl, loadData,
                                               setLoadData, size, page,
                                               setTotalPages, setTotalElements,
                                               sort, setSort, setPage
                                           }) {

    const [data, setData] = useState([])
    const [error, setError] = useState(false)
    const [filter, setFilter] = useState({})

    const titles = [
        'Lote',
        'Parcela',
        'Usuário',
        'Alteração(ões)',
        'Data da Alteração',
        'Data de Vencimento Atual',
        'Status da Parcela',
    ]

    return (
        <>
            <FilterDueDateChanges
                filter={filter} setFilter={setFilter}
                setLoadData={setLoadData} setPage={setPage}/>
            <TableList
                titles={titles} baseUrl={baseUrl}
                page={page} sort={sort} size={size}
                loadData={loadData}
                setTotalPages={setTotalPages} setTotalElements={setTotalElements}
                setData={setData} setLoadData={setLoadData} filter={filter}
                error={error} setError={setError}
            >
                {data.map((item) =>
                    <tr key={item.id}>
                        <td>{item.numeroLote} - {item.evento}</td>
                        <td>{item.numeroParcela}</td>
                        <td>{item.username}</td>
                        <td>
                            {item.newDate !== item.oldDate &&
                                `${normalizeTimestemp(item.oldDate)} -> ${normalizeTimestemp(item.newDate)}`}

                            {item.newDate !== item.oldDate && item.oldValue !== item.newValue && <br/>}

                            {item.oldValue !== item.newValue &&
                                `R$ ${numberWithPoints(item.oldValue)} -> R$ ${numberWithPoints(item.newValue)}`}
                        </td>
                        <td>{normalizeTimestemp(item.dataAlteracao)}</td>
                        <td>{normalizeTimestemp(item.dataVencimentoAtual)}</td>
                        <td>{item.statusParcela}</td>
                        <td><DueDateChangesActions item={item} setLoadData={setLoadData}/></td>
                    </tr>
                )}
            </TableList>
        </>
    )
}